import { useContext } from 'react';
import { useLocation } from 'react-router';
import { BrandContext } from '../../contexts/brand-context';

const DefaultHeaderTags = () => {
    const { selectedBrand } = useContext(BrandContext);
    const location = useLocation();

    const toTitleCase = (str) => {
        return str.toLowerCase().replace(/(?:^|[\s-/])\w/g, function (match) {
            return match.toUpperCase();
        }).replace(/[/-]/g, " ");
    }

    return (
        <title>{toTitleCase(location.pathname) + (selectedBrand && selectedBrand.brandId !== 3 ? ` : ${selectedBrand.brandName}` : "")}</title>
    );
}

export default DefaultHeaderTags;